import { Box, Button, Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppContext } from '../../../context/appContext';

const ErrorPanel = ({ onReload, hideErrorImg }) => {
  const { t } = useTranslation();
  const { staticResourceHost } = useAppContext();
  return (
    <Flex alignItems="center" flexDirection="column">
      {!hideErrorImg && (
        <img
          src={`${staticResourceHost}admin/v2/img/member_center/member_center_page_error.png`}
          width="108"
          alt="error image"
        />
      )}
      <Box paddingBottom="20px" paddingTop="20px" textAlign="center">
        <Text variant="hint" className="member-center-profile__hint-text">
          {t('member_profile.error.unknown')}
        </Text>
        <Text variant="hint" className="member-center-profile__hint-text">
          {t('member_profile.error.refresh')}
        </Text>
      </Box>
      <Button
        width="210px"
        variant="fill"
        onClick={onReload}
        className="member-center-profile__retry-button member-center-profile__primary-button"
      >
        {t('member_profile.retry')}
      </Button>
    </Flex>
  );
};

ErrorPanel.propTypes = {
  onReload: PropTypes.func,
  hideErrorImg: PropTypes.bool,
};

export default ErrorPanel;
